import { styled } from '@mui/material/styles';
import React from 'react';

import { Box, Grid, Typography } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  height: '100%',
  background: theme.palette.common.white,
  borderRadius: 8,
  padding: theme.spacing(4),
}));

const Text = styled(Typography)(({ theme }) => ({
  textTransform: 'none',
  color: theme.palette.darkBlue.main,
}));

type Props = {
  items: {
    title: React.ReactNode;
    text: React.ReactNode;
    icon?: React.ReactNode;
    planName?: string;
  }[];
};

const TopPerformanceCards: React.FC<Props> = ({ items }) => {
  return (
    <Grid container spacing={4}>
      {items.map((item, idx) => (
        <Grid key={idx} size={{ xs: 12, md: 4 }}>
          <StyledBox>
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Text textAlign={'left'}>{item.title}</Text>
              {item.icon}
            </Box>
            <Text>
              <b>{item.planName} </b>
              {item.text}
            </Text>
          </StyledBox>
        </Grid>
      ))}
    </Grid>
  );
};

export default React.memo(TopPerformanceCards);
